import { z } from 'zod'

const moneySchema = z.object({
    amount: z.string().regex(/^-?\d+(?:\.\d+)?$/),
    currency: z.string().length(3),
})

const settlementSchema = z.object({
    uuid: z.string().uuid(),
    createdAt: z.string().datetime({ offset: true }),
    orderUuid: z.string().uuid(),
    orderTotalPrice: moneySchema.optional(),
})

export const firebaseOpenTabSummarySchema = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    state: z.enum(['open', 'closed', 'cancelled']),
    createdAt: z.string().datetime({ offset: true }),
    totalPrice: moneySchema.nullish().transform((value) => value ?? null),
    unsettledPrice: moneySchema.nullish().transform((value) => value ?? null),
    settlements: z.preprocess((value) => value ?? [], z.array(settlementSchema)),
})

export type FirebaseOpenTabSummary = z.infer<typeof firebaseOpenTabSummarySchema>
